export enum UserStateEnum {
    exist,
    exist_not_confirmed,
    not_exist
}